export const VoiceCallStatus = Object.freeze({
    initiating: "Initiating",
    calling: "Calling",
    ongoing: "Ongoing",
    ended: "Ended",
    error: "Error",
});
